export const NEW_SEARCH_WIDGET = {
  allSportsId: -1,
  mobilePreviewResults: 10,
  mobilePreviewTopEntities: 6,
  minimumCharacters: 2,
  maximumCharacters: 30,

  LIST_ID: {
    topCompetitions: 0,
    topCompetitors: 1,
    topAthletes: 2,
    searchCompetitions: 3,
    searchCompetitors: 4,
    searchAthletes: 5,
    recentSearches: 6,
  },

  ACTION_TYPES: {
    FETCH: {
      onSearchFetch: 'onSearchFetch',
      onSportTypesFetch: 'onSportTypesFetch',
      onRecentFetch: 'onRecentFetch'
    },

    CLICK: {
      onChangeQuery: 'onChangeQuery',
      onSportTypeClick: 'onSportTypeClick',
      onSportTypeMenuClick: 'onSportTypeMenuClick',
      entityClickHandler: 'entityClickHandler',
      onClearRecent: 'onClearRecent',
      onSeeAllClick: 'onSeeAllClick',
      onTabClick: 'onTabClick'
    },

    TOP_ENTITIES: {
      fetchCompetitors: 'fetchCompetitors',
      fetchCompetitions: 'fetchCompetitions',
      fetchAthletes: 'fetchAthletes'
    },

    RESET: {
      onSearchReset: 'onSearchReset'
    },

    ANALYTICS: {
      onSearchEnded: 'onSearchEnded',
      onClearClickEvent: 'onClearClickEvent',
      onSearchClickEvent: 'onSearchClickEvent',
      onSportTypeClickEvent: 'onSportTypeClickEvent',
      onSeeAllClickEvent: 'onSeeAllClickEvent',
      onNextActionQueryEvent: 'onNextActionQueryEvent'
    }
  },

  RESULT_TYPE: {
    starClick: 2,
    entityClick: 1,
    other: 0
  },

  MAX_TOP_ENTITIES: {
    desktop: 10,
    mobile: 100
  },

  TAB_SECTION: {
    default: -1,
    popularAndResults: 0,
    recentSearches: 1,
    sportsDropdown: 2
  },

  HIGHLIGHTED_LIST_INDEX: {
    competitions: 0,
    competitors: 1,
    athletes: 2,
  },

  DIRECTIONS: {
    next: "next",
    prev: "prev"
  },

  ANALYTICS: {
    SUB_SOURCES: {
      result: 'result',
      top: 'top'
    },
    NEXT_ACTION: {
      exit: -1,
      entityClick: 0
    },
    RESULTS_FOR_SEARCH: {
      hasMatches: 1,
      noMatches: 2
    },
    SEARCH_STATUS: {
      unTouched: 0,
      deleted: 1,
      hasQuery: 2
    }
  }
};
